module.exports = __webpack_public_path__ + "img/title-back.512dc377.png";